// Attempt to create an enum object in JavaScript

export default class AnalyticalMethod {
	// constructor is locked by default, new instances must be created with #create() method.
	static #CONSTRUCTOR_LOCKED = true;
	// The methods we support for now.
	static #SUPPORTED_METHODS = ["MS", "ELS", "CA", "EC", "RI", "FI", "RADIO", "UV", "CUSTOM"];

	static MS = AnalyticalMethod.fromString("MS");
	static ELS = AnalyticalMethod.fromString("ELS");
	static CA = AnalyticalMethod.fromString("CA");
	static EC = AnalyticalMethod.fromString("EC");
	static RI = AnalyticalMethod.fromString("RI");
	static FI = AnalyticalMethod.fromString("FI");
	static RADIO = AnalyticalMethod.fromString("RADIO");
	static UV = AnalyticalMethod.fromString("UV");
	static CUSTOM = AnalyticalMethod.fromString("CUSTOM");

	#name;

	constructor(name) {
		if (AnalyticalMethod.#CONSTRUCTOR_LOCKED)
			throw new Error("AnalyticalMethod is not constructable, use AnalyticalMethod.create(name) instead");
		this.#name = name;
	}

	/**
	 * @param {string} name
	 * @return {AnalyticalMethod}
	 */
	static fromString(name) {
		if (!this.#SUPPORTED_METHODS.includes(name))
			return AnalyticalMethod.CUSTOM;
		try {
			AnalyticalMethod.#CONSTRUCTOR_LOCKED = false;
			// this actually happens when static fields are initialized.
			if (!Object.keys(this).includes(name))
				AnalyticalMethod[name] = new AnalyticalMethod(name);
			return AnalyticalMethod[name]
		} finally {
			AnalyticalMethod.#CONSTRUCTOR_LOCKED = true;
		}
	}

	get name() {
		return this.#name;
	}
}
